import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import cloneDeep from 'lodash.clonedeep';
import set from 'lodash.set';
export function isObject(obj) {
    return obj && typeof obj === 'object';
}
export const findFunctions = (obj, path, result) => {
    result = result || {};
    if (!isObject(obj)) {
        return result;
    }
    for (const key in obj) {
        const value = obj[key];
        const newPath = path ? `${path}.${key}` : key;
        if (value instanceof Function) {
            result[newPath] = value;
        }
        else if (isObject(value)) {
            findFunctions(value, newPath, result);
        }
    }
    return result;
};
export function stringifyObject(obj) {
    let fnMap = {};
    // TODO: Use `structuredClone` as soon as Next.js supports it.
    let objCopy = cloneDeep(obj);
    // Replace functions with placeholders.
    if (isObject(objCopy)) {
        fnMap = findFunctions(objCopy);
        for (const path in fnMap) {
            set(objCopy, path, `%%%${path}%%%`);
        }
    }
    // Stringify the object.
    let result = JSON.stringify(objCopy);
    // Replace placeholders with function strings.
    for (const path in fnMap) {
        const fnString = fnMap[path].toString();
        result = result.replace(`"%%%${path}%%%"`, fnString);
    }
    return result;
}
export function CohesionSnippet({ config, src = 'https://cdn.cohesionapps.com/cohesion/cohesion-latest.min.js', }) {
    const configStr = stringifyObject(config);
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `.preampjs [data-preamp], .fusejs [data-fuse] { opacity: 0 !important}` }), _jsx("script", { dangerouslySetInnerHTML: {
                    __html: `
            !function(co,h,e,s,i,o,n){var d='documentElement';var a='className';h[d][a]+=' preampjs fusejs';
            n.k=e;co._Cohesion=n;co._Preamp={k:s,start:new Date};co._Fuse={k:i};co._Tagular={k:o};
            [e,s,i,o].map(function(x){co[x]=co[x]||function(){(co[x].q=co[x].q||[]).push([].slice.call(arguments))}});
            var b=function(){var u=h[d][a];h[d][a]=u.replace(/ ?preampjs| ?fusejs/g,'')};
            h.addEventListener('DOMContentLoaded',function(){co.setTimeout(b,3e3);
            co._Preamp.docReady=co._Fuse.docReady=!0});var z=h.createElement('script');
            z.async=1;z.src='${src}';
            z.onerror=function(){var ce='error',f='function';for(var o of co[e].q||[])o[0]===ce&&typeof o[1]==f&&o[1]();co[e]=function(n,cb){n===ce&&typeof cb==f&&cb()};b()};
            h.head.appendChild(z);}
            (window,document,'cohesion','preamp','fuse','tagular',${configStr});
          `,
                } })] }));
}
